export default {
    setItems(state, items) {
        state.items = items;
    },
    addItem(state, item) {
        state.items.push(item)
    },
}